<template>
    <div class="shensha-container">
        <!-- 神煞卡片 -->
        <h3 class="card-title">神煞排盘</h3>

        <div class="shensha-card glow-card">

            <div class="shensha-grid">
                <!-- 表头 -->
                <div class="grid-header"></div>
                <div class="grid-header">年柱</div>
                <div class="grid-header">月柱</div>
                <div class="grid-header">日柱</div>
                <div class="grid-header">时柱</div>
                <div class="grid-header">大运</div>
                <div class="grid-header">流年</div>
                <div class="grid-header">流月</div>
                <div class="grid-header">流日</div>
                <div class="grid-header">流时</div>

                <!-- 神煞数据行 -->
                <template v-for="(row, index) in shenshaRows" :key="index">
                    <div class="grid-label" v-if="index === 0">神煞</div>
                    <div class="grid-label" v-else></div>

                    <div class="grid-cell multi-line" v-for="(col, colIndex) in columns" :key="colIndex">
                        {{ formatShenSha(data[col], index) }}
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script setup>
import axios from '@/utils/axios'; // 使用自定义 axios 实例
import { computed, defineProps, onMounted, ref, watch } from 'vue';
const props = defineProps({
    gans: { type: Array, required: true },
    zhis: { type: Array, required: true },
    refresh: { type: Number, default: 0 } // 新增 refresh prop
})

const data = ref({})
const loading = ref(false)
const columns = ref(['年柱', '月柱', '日柱', '时柱', '大运', '流年', '流月', '流日', '流时'])
const maxRows = ref(0)

// 计算最大行数
const shenshaRows = computed(() => {
    return Array.from({ length: maxRows.value || 1 })
})

// 格式化神煞显示
const formatShenSha = (shenshaList, rowIndex) => {
    if (!shenshaList || !Array.isArray(shenshaList)) return ''
    return shenshaList[rowIndex] || ''
}

// 获取神煞数据
const fetchShenSha = async () => {
    if (!props.gans.length || !props.zhis.length) return // 防止空数据请求
    loading.value = true
    try {
        const res = await axios.post(`/api/rili/v3/bazi/shensha`, {
            gans: props.gans,
            zhis: props.zhis
        }
        )

        data.value = res.data.data
        // 计算最大行数
        maxRows.value = Math.max(...Object.values(data.value).map(arr => arr.length))
    } catch (e) {
        console.error('获取神煞数据失败:', e)
    } finally {
        loading.value = false
    }
}

// 监听 refresh 和 props.gans, props.zhis，触发数据更新
watch([() => props.refresh, () => props.gans, () => props.zhis], () => {
    if (props.gans.length && props.zhis.length) {
        fetchShenSha()
    }
}, { immediate: true })
onMounted(() => {
    fetchShenSha()
})
</script>

<style scoped>
.shensha-container {
    margin-top: 20px;
}

/* 神煞卡片样式 */
.shensha-card {
    background: rgba(30, 30, 40, 0.8);
    border-radius: 12px;
    padding: 20px;
    border: 1px solid rgba(110, 90, 210, 0.3);
    box-shadow: 0 0 15px rgba(110, 90, 210, 0.2);
}

/* 网格布局 */
.shensha-grid {
    display: grid;
    grid-template-columns: 60px repeat(9, 1fr);
    gap: 8px;
}

.grid-header {
    background: rgba(110, 90, 210, 0.2);
    padding: 10px;
    text-align: center;
    font-weight: bold;
    color: #b0a0ff;
    border-radius: 6px;
}

.grid-label {
    background: rgba(70, 60, 120, 0.3);
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    border-radius: 6px;
}

.grid-cell {
    background: rgba(40, 40, 60, 0.5);
    padding: 10px;
    text-align: center;
    border-radius: 6px;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.multi-line {
    white-space: pre-line;
    line-height: 1.6;
}

/* 神煞特殊样式 */
.shensha-item {
    margin: 2px 0;
    padding: 2px 5px;
    border-radius: 4px;
    background: rgba(147, 112, 219, 0.2);
}

/* 响应式调整 */
@media (max-width: 1200px) {
    .shensha-grid {
        grid-template-columns: 50px repeat(9, 1fr);
        font-size: 13px;
    }
}
</style>